import lodash from "@/lodash";
const { curry } = lodash;

// Module for dom-manipulation helper functions related to Stimulus 
export function addDataAttribute(attribute: string, element: HTMLElement, value: string) {
    element.dataset[attribute] = addToDataAttribute(element.dataset[attribute], value);
}

function addToDataAttribute(attribute: string, value: string) {
    if (attribute) {
        if (attribute.indexOf(value) !== -1) {
            return attribute;
        }
        return `${attribute} ${value}`;
    }
    return value;
}

export function removeDataAttribute(attribute: string, element: HTMLElement, value: string) {
    element.dataset[attribute] = removeFromDataAttribute(element.dataset[attribute], value);
}

function removeFromDataAttribute(attribute: string, controller: string) {
    if (attribute) {
        return attribute.replace(controller, '').trim();
    }
    return '';
}

export function hasDataAttribute(attribute: string, element: HTMLElement, value: string): boolean {
    let attr = element.dataset[attribute];
    return attr ? attr.indexOf(value) !== -1 : false;
}


const addAttr = curry(addDataAttribute);
const rmAttr = curry(removeDataAttribute);
const hasAttr = curry(hasDataAttribute);
export const addController = addAttr('controller');
export const removeController = rmAttr('controller');
export const hasController = hasAttr('controller');  
export const addAction = addAttr('action');
export const removeAction = rmAttr('action');


/** Similar to HTMLElement.closest function, except it is not limited to returning ancestors */
export function closestTo(el: HTMLElement, selector: string) {
    let matchingEl: HTMLElement;
    for (let parentEl = el.parentElement; !!parentEl; parentEl = parentEl.parentElement) {
        if (matchingEl = parentEl.querySelector(selector)) {
            return matchingEl;
        }
    }
    return null;
}
/**
 * Parses and returns data stored in a <script type='application/json'>...</script> element.
 * Removes the script from the DOM after extracting the data.
 * Returns NULL if the script does not exist.
 **/

export function importJson(containerEl: HTMLElement, selector = "script") {
    let scriptEl = containerEl.querySelector(selector);
    if (scriptEl instanceof HTMLScriptElement) {
        return importJsonFromScript(scriptEl);
    }
    return null;
}

export function importJsonFromScript<T = any>(scriptEl: HTMLScriptElement): T {
    let data = JSON.parse(scriptEl.innerHTML);
    scriptEl.remove();
    return data;
}
